// import React, { useState, useEffect, useCallback } from 'react';
// import { 
//   FileText, User, Building, Download, Plus, Filter, 
//   LogOut, Search, Trash2, Activity, CheckCircle, XCircle, AlertCircle, X
// } from 'lucide-react';

// // Configurare API
// // const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
// const API_URL = process.env.REACT_APP_API_URL || 'https://registru.blueforest.ro/api';
// // Helper pentru request-uri API
// // Helper pentru request-uri API
// const apiRequest = async (endpoint, options = {}) => {
//   const token = localStorage.getItem('token');
//   const defaultOptions = {
//     headers: {
//       'Content-Type': 'application/json',
//       'ngrok-skip-browser-warning': 'true', // ADAUGĂ ASTA!
//       ...(token && { 'Authorization': `Bearer ${token}` })
//     }
//   };

//   const response = await fetch(`${API_URL}${endpoint}`, {
//     ...defaultOptions,
//     ...options,
//     headers: { ...defaultOptions.headers, ...options.headers }
//   });

//   if (!response.ok) {
//     if (response.status === 401) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }
//     throw new Error(`API Error: ${response.status}`);
//   }

//   return response.json();
// };

// // Componenta de Notificare Custom
// const Notification = ({ type, message, onClose }) => {
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       onClose();
//     }, 5000); // Se închide automat după 5 secunde

//     return () => clearTimeout(timer);
//   }, [onClose]);

//   const styles = {
//     success: {
//       bg: 'bg-green-50',
//       border: 'border-green-400',
//       text: 'text-green-800',
//       icon: <CheckCircle className="w-5 h-5" />,
//       iconColor: 'text-green-400'
//     },
//     error: {
//       bg: 'bg-red-50',
//       border: 'border-red-400',
//       text: 'text-red-800',
//       icon: <XCircle className="w-5 h-5" />,
//       iconColor: 'text-red-400'
//     },
//     warning: {
//       bg: 'bg-yellow-50',
//       border: 'border-yellow-400',
//       text: 'text-yellow-800',
//       icon: <AlertCircle className="w-5 h-5" />,
//       iconColor: 'text-yellow-400'
//     },
//     info: {
//       bg: 'bg-blue-50',
//       border: 'border-blue-400',
//       text: 'text-blue-800',
//       icon: <AlertCircle className="w-5 h-5" />,
//       iconColor: 'text-blue-400'
//     }
//   };

//   const style = styles[type] || styles.info;

//   return (
//     <div className="fixed top-4 right-4 z-50 animate-slide-in">
//       <div className={`${style.bg} border ${style.border} ${style.text} px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] max-w-[500px]`}>
//         <span className={style.iconColor}>{style.icon}</span>
//         <p className="flex-1">{message}</p>
//         <button
//           onClick={onClose}
//           className={`${style.iconColor} hover:opacity-70 transition-opacity`}
//         >
//           <X className="w-4 h-4" />
//         </button>
//       </div>
//     </div>
//   );
// };

// // Componenta de Confirmare Custom
// const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, type = 'warning' }) => {
//   if (!isOpen) return null;

//   const styles = {
//     warning: {
//       icon: <AlertCircle className="w-12 h-12 text-yellow-500" />,
//       confirmBtn: 'bg-yellow-600 hover:bg-yellow-700'
//     },
//     danger: {
//       icon: <XCircle className="w-12 h-12 text-red-500" />,
//       confirmBtn: 'bg-red-600 hover:bg-red-700'
//     }
//   };

//   const style = styles[type] || styles.warning;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4 animate-scale-in">
//         <div className="flex flex-col items-center text-center">
//           {style.icon}
//           <h3 className="text-xl font-bold mt-4 mb-2">{title}</h3>
//           <p className="text-gray-600 mb-6">{message}</p>
//           <div className="flex gap-3 w-full">
//             <button
//               onClick={onCancel}
//               className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
//             >
//               Anulează
//             </button>
//             <button
//               onClick={onConfirm}
//               className={`flex-1 px-4 py-2 text-white rounded-lg transition-colors ${style.confirmBtn}`}
//             >
//               Confirmă
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Adaugă aceste stiluri CSS pentru animații
// const styles = `
//   @keyframes slide-in {
//     from {
//       transform: translateX(100%);
//       opacity: 0;
//     }
//     to {
//       transform: translateX(0);
//       opacity: 1;
//     }
//   }

//   @keyframes scale-in {
//     from {
//       transform: scale(0.9);
//       opacity: 0;
//     }
//     to {
//       transform: scale(1);
//       opacity: 1;
//     }
//   }

//   .animate-slide-in {
//     animation: slide-in 0.3s ease-out;
//   }

//   .animate-scale-in {
//     animation: scale-in 0.2s ease-out;
//   }
// `;

// // Adaugă stilurile în document
// if (typeof document !== 'undefined') {
//   const styleSheet = document.createElement('style');
//   styleSheet.textContent = styles;
//   document.head.appendChild(styleSheet);
// }

// // Componenta de Login
// const LoginPage = ({ onLogin }) => {
//   const [credentials, setCredentials] = useState({ username: '', password: '' });
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const data = await apiRequest('/auth/login', {
//         method: 'POST',
//         body: JSON.stringify(credentials)
//       });

//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user));
//       onLogin(data.user);
//     } catch (err) {
//       setError('Utilizator sau parolă incorectă');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
//       <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
//         <div className="text-center mb-8">
//           <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
//             <FileText className="w-8 h-8" />
//           </div>
//           <h1 className="text-2xl font-bold text-gray-800">Registru Electronic</h1>
//           <p className="text-gray-600 mt-2">Sistem de înregistrare documente</p>
//         </div>

//         {error && (
//           <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg mb-4">
//             {error}
//           </div>
//         )}

//         <div className="space-y-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Utilizator
//             </label>
//             <input
//               type="text"
//               value={credentials.username}
//               onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               placeholder="Introduceți numele de utilizator"
//               required
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Parolă
//             </label>
//             <input
//               type="password"
//               value={credentials.password}
//               onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
//               onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               placeholder="Introduceți parola"
//               required
//             />
//           </div>

//           <button
//             onClick={handleSubmit}
//             disabled={loading}
//             className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50"
//           >
//             {loading ? 'Se conectează...' : 'Conectare'}
//           </button>
//         </div>

//         <div className="mt-6 text-center text-sm text-gray-500">
//           <p>Utilizatori disponibili:</p>
//           <p className="mt-1">Admin: emilia | Useri: cosmin, radu, nicu, darius, rares, felicia</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Dashboard View Component
// const DashboardView = ({ statistics, user, year, onYearChange }) => (
//   <div className="p-6">
//     <div className="flex justify-between items-center mb-6">
//       <h2 className="text-2xl font-bold">Dashboard</h2>
//       <select
//         value={year}
//         onChange={(e) => onYearChange(parseInt(e.target.value))}
//         className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//       >
//         <option value="2024">2024</option>
//         <option value="2025">2025</option>
//       </select>
//     </div>
    
//     {/* Statistici pe companii */}
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//       {statistics?.companyStats.map(company => (
//         <div key={company.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
//           <div className="flex items-center justify-between mb-4">
//             <div className="w-12 h-12 rounded-full flex items-center justify-center" 
//                  style={{ backgroundColor: company.color + '20' }}>
//               <Building className="w-6 h-6" style={{ color: company.color }} />
//             </div>
//             <span className="text-2xl font-bold">{company.total_documents}</span>
//           </div>
//           <h3 className="font-semibold text-gray-800">{company.short_name}</h3>
//           <div className="mt-2 text-sm text-gray-600">
//             <p>Intrări: {company.total_intrari}</p>
//             <p>Ieșiri: {company.total_iesiri}</p>
//           </div>
//         </div>
//       ))}
//     </div>

//     {/* Activitate recentă */}
//     <div className="bg-white rounded-lg shadow-md p-6">
//       <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
//         <Activity className="w-5 h-5" />
//         Activitate Recentă
//       </h3>
//       <div className="overflow-x-auto">
//         <table className="w-full">
//           <thead>
//             <tr className="border-b">
//               <th className="text-left p-2">Nr.</th>
//               <th className="text-left p-2">Data</th>
//               <th className="text-left p-2">Companie</th>
//               <th className="text-left p-2">Tip</th>
//               <th className="text-left p-2">Creat de</th>
//             </tr>
//           </thead>
//           <tbody>
//             {statistics?.recentActivity.map(doc => (
//               <tr key={doc.id} className="border-b hover:bg-gray-50">
//                 <td className="p-2">{doc.number}</td>
//                 <td className="p-2">{new Date(doc.date).toLocaleDateString('ro-RO')}</td>
//                 <td className="p-2">{doc.company_name}</td>
//                 <td className="p-2">
//                   <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
//                     doc.registry_type === 'intrare' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
//                   }`}>
//                     {doc.registry_type}
//                   </span>
//                 </td>
//                 <td className="p-2">{doc.created_by_name}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   </div>
// );

// // Documents View Component
// const DocumentsView = ({ 
//   companies, 
//   documents, 
//   loading, 
//   filters, 
//   setFilters, 
//   onAddNew, 
//   onExport, 
//   onLoadDocuments,
//   onDeleteDocument,
//   user 
// }) => (
//   <div className="p-6">
//     <div className="flex justify-between items-center mb-6">
//       <h2 className="text-2xl font-bold">Documente</h2>
//       <div className="flex gap-2">
//         <button
//           onClick={onAddNew}
//           className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
//         >
//           <Plus className="w-4 h-4" />
//           Document Nou
//         </button>
//         <button
//           onClick={onExport}
//           className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center gap-2"
//         >
//           <Download className="w-4 h-4" />
//           Export CSV
//         </button>
//       </div>
//     </div>

//     {/* Filtre */}
//     <div className="bg-white rounded-lg shadow-md p-4 mb-6">
//       <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//         <select
//           value={filters.company_id}
//           onChange={(e) => setFilters({ ...filters, company_id: e.target.value })}
//           className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="">Toate companiile</option>
//           {companies.map(company => (
//             <option key={company.id} value={company.id}>{company.name}</option>
//           ))}
//         </select>

//         <select
//           value={filters.registry_type}
//           onChange={(e) => setFilters({ ...filters, registry_type: e.target.value })}
//           className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//         >
//           <option value="">Toate tipurile</option>
//           <option value="intrare">Intrări</option>
//           <option value="iesire">Ieșiri</option>
//         </select>

//         <input
//           type="number"
//           value={filters.year}
//           onChange={(e) => setFilters({ ...filters, year: e.target.value })}
//           className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//           placeholder="An"
//         />

//         <div className="relative">
//           <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
//           <input
//             type="text"
//             value={filters.search}
//             onChange={(e) => setFilters({ ...filters, search: e.target.value })}
//             className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 w-full"
//             placeholder="Caută..."
//           />
//         </div>

//         <button
//           onClick={onLoadDocuments}
//           className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 flex items-center justify-center gap-2"
//         >
//           <Filter className="w-4 h-4" />
//           Filtrează
//         </button>
//       </div>
//     </div>

//     {/* Tabel documente */}
//     <div className="bg-white rounded-lg shadow-md overflow-hidden">
//       {loading ? (
//         <div className="p-8 text-center">Se încarcă...</div>
//       ) : (
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="p-3 text-left">Nr.</th>
//                 <th className="p-3 text-left">Nr. Intrare</th>
//                 <th className="p-3 text-left">Data</th>
//                 <th className="p-3 text-left">Companie</th>
//                 <th className="p-3 text-left">Tip</th>
//                 <th className="p-3 text-left">De la</th>
//                 <th className="p-3 text-left">La</th>
//                 <th className="p-3 text-left">Conține</th>
//                 <th className="p-3 text-left">Creat de</th>
//                 {user.role === 'admin' && <th className="p-3 text-left">Acțiuni</th>}
//               </tr>
//             </thead>
//             <tbody>
//               {documents.map(doc => (
//                 <tr key={doc.id} className="border-b hover:bg-gray-50">
//                   <td className="p-3 font-semibold">{doc.number}</td>
//                   <td className="p-3">{doc.number_intrare || '-'}</td>
//                   <td className="p-3">{new Date(doc.date).toLocaleDateString('ro-RO')}</td>
//                   <td className="p-3">
//                     <span className="px-2 py-1 rounded-full text-xs font-semibold text-white"
//                           style={{ backgroundColor: doc.company_color }}>
//                       {doc.company_short}
//                     </span>
//                   </td>
//                   <td className="p-3">
//                     <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
//                       doc.registry_type === 'intrare' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
//                     }`}>
//                       {doc.registry_type}
//                     </span>
//                   </td>
//                   <td className="p-3 text-sm">{doc.from_entity}</td>
//                   <td className="p-3 text-sm">{doc.to_entity}</td>
//                   <td className="p-3 text-sm">{doc.content}</td>
//                   <td className="p-3 text-sm">{doc.created_by_name}</td>
//                   {user.role === 'admin' && (
//                     <td className="p-3">
//                       <button
//                         onClick={() => onDeleteDocument(doc.id)}
//                         className="text-red-600 hover:text-red-800"
//                         title="Șterge document"
//                       >
//                         <Trash2 className="w-4 h-4" />
//                       </button>
//                     </td>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   </div>
// );

// // Add Document Form Component
// const AddDocumentForm = ({ companies, formData, setFormData, onSave, onCancel }) => {
//   const [saving, setSaving] = useState(false);
  
//   const handleSave = async () => {
//     setSaving(true);
//     await onSave();
//     setSaving(false);
//   };
  
//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//         <h3 className="text-xl font-bold mb-4">Adaugă Document Nou</h3>
        
//         <div className="grid grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Companie <span className="text-red-500">*</span>
//             </label>
//             <select
//               value={formData.company_id}
//               onChange={(e) => setFormData({ ...formData, company_id: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//               required
//             >
//               <option value="">Selectează...</option>
//               {companies.map(company => (
//                 <option key={company.id} value={company.id}>{company.name}</option>
//               ))}
//             </select>
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Tip Registru <span className="text-red-500">*</span>
//             </label>
//             <select
//               value={formData.registry_type}
//               onChange={(e) => setFormData({ ...formData, registry_type: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="iesire">Ieșire</option>
//               <option value="intrare">Intrare</option>
//             </select>
//           </div>

//           {formData.registry_type === 'intrare' && (
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Nr. Intrare
//               </label>
//               <input
//                 type="text"
//                 value={formData.number_intrare}
//                 onChange={(e) => setFormData({ ...formData, number_intrare: e.target.value })}
//                 className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
//           )}

//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Data <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="date"
//               value={formData.date}
//               onChange={(e) => setFormData({ ...formData, date: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//               required
//             />
//           </div>

//           <div className="col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               De la / Von <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="text"
//               value={formData.from_entity}
//               onChange={(e) => setFormData({ ...formData, from_entity: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//               required
//             />
//           </div>

//           <div className="col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               La / Zu <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="text"
//               value={formData.to_entity}
//               onChange={(e) => setFormData({ ...formData, to_entity: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//               required
//             />
//           </div>

//           <div className="col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Conține / Enthält <span className="text-red-500">*</span>
//             </label>
//             <textarea
//               value={formData.content}
//               onChange={(e) => setFormData({ ...formData, content: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//               rows="3"
//               required
//             />
//           </div>

//           {formData.registry_type === 'intrare' && (
//             <>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Redirecționare
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.redirectionare}
//                   onChange={(e) => setFormData({ ...formData, redirectionare: e.target.value })}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   OPID
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.opid}
//                   onChange={(e) => setFormData({ ...formData, opid: e.target.value })}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             </>
//           )}
//         </div>

//         <div className="flex justify-end gap-2 mt-6">
//           <button
//             onClick={onCancel}
//             disabled={saving}
//             className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
//           >
//             Anulează
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={saving}
//             className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed ${
//               saving ? 'animate-pulse' : ''
//             }`}
//           >
//             {saving ? 'Se salvează...' : 'Salvează'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Componenta principală
// const DocumentRegistry = () => {
//   const [user, setUser] = useState(null);
//   const [companies, setCompanies] = useState([]);
//   const [documents, setDocuments] = useState([]);
//   const [statistics, setStatistics] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [activeView, setActiveView] = useState('dashboard');
//   const [dashboardYear, setDashboardYear] = useState(2025);
  
//   // State pentru notificări
//   const [notification, setNotification] = useState(null);
//   const [confirmDialog, setConfirmDialog] = useState({
//     isOpen: false,
//     title: '',
//     message: '',
//     onConfirm: null,
//     type: 'warning'
//   });
  
//   // Filtre pentru documente
//   const [filters, setFilters] = useState({
//     company_id: '',
//     registry_type: '',
//     year: 2025,
//     search: ''
//   });

//   // Form pentru document nou
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [formData, setFormData] = useState({
//     company_id: '',
//     registry_type: 'iesire',
//     number_intrare: '',
//     date: new Date().toISOString().split('T')[0],
//     from_entity: '',
//     to_entity: '',
//     content: '',
//     redirectionare: '',
//     opid: ''
//   });

//   // Funcții helper pentru notificări
//   const showNotification = (type, message) => {
//     setNotification({ type, message });
//   };

//   const showConfirmDialog = (title, message, onConfirm, type = 'warning') => {
//     setConfirmDialog({
//       isOpen: true,
//       title,
//       message,
//       onConfirm: () => {
//         onConfirm();
//         setConfirmDialog({ ...confirmDialog, isOpen: false });
//       },
//       type
//     });
//   };

//   // Încărcare companii
//   const loadCompanies = async () => {
//     try {
//       const data = await apiRequest('/companies');
//       setCompanies(data);
//     } catch (error) {
//       console.error('Eroare la încărcare companii:', error);
//     }
//   };

//   // Încărcare statistici - folosește useCallback pentru a evita re-crearea
//   const loadStatistics = useCallback(async () => {
//     try {
//       const data = await apiRequest(`/statistics?year=${dashboardYear}`);
//       setStatistics(data);
//     } catch (error) {
//       console.error('Eroare la încărcare statistici:', error);
//     }
//   }, [dashboardYear]);

//   // Încărcare documente - folosește useCallback pentru a evita re-crearea
//   const loadDocuments = useCallback(async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams();
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) queryParams.append(key, value);
//       });

//       const data = await apiRequest(`/documents?${queryParams}`);
//       setDocuments(data.documents);
//     } catch (error) {
//       console.error('Eroare la încărcare documente:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters]);

//   // Verificare autentificare la încărcare
//   useEffect(() => {
//     const savedUser = localStorage.getItem('user');
//     if (savedUser) {
//       setUser(JSON.parse(savedUser));
//     }
//   }, []);

//   // Încărcare date inițiale
//   useEffect(() => {
//     if (user) {
//       loadCompanies();
//     }
//   }, [user]);

//   // Încărcare date pe baza view-ului activ
//   useEffect(() => {
//     if (user) {
//       if (activeView === 'dashboard') {
//         loadStatistics();
//       } else if (activeView === 'documents') {
//         loadDocuments();
//       }
//     }
//   }, [user, activeView, loadStatistics, loadDocuments]);

//   // Reîncărcare statistici când se schimbă anul dashboard-ului
//   useEffect(() => {
//     if (user && activeView === 'dashboard') {
//       loadStatistics();
//     }
//   }, [dashboardYear, user, activeView, loadStatistics]);

//   // Adăugare document
//   const handleAddDocument = async () => {
//     try {
//       const response = await apiRequest('/documents', {
//         method: 'POST',
//         body: JSON.stringify(formData)
//       });

//       showNotification('success', `Document înregistrat cu succes! Număr generat: ${response.generatedNumber}`);
//       setShowAddForm(false);
//       setFormData({
//         company_id: '',
//         registry_type: 'iesire',
//         number_intrare: '',
//         date: new Date().toISOString().split('T')[0],
//         from_entity: '',
//         to_entity: '',
//         content: '',
//         redirectionare: '',
//         opid: ''
//       });
      
//       loadDocuments();
//       loadStatistics();
//     } catch (error) {
//       showNotification('error', 'Eroare la adăugare document. Vă rugăm încercați din nou.');
//     }
//   };

//   // Ștergere document (doar pentru admin)
//   const handleDeleteDocument = async (documentId) => {
//     showConfirmDialog(
//       'Confirmare ștergere',
//       'Sigur doriți să ștergeți acest document? Această acțiune nu poate fi anulată.',
//       async () => {
//         try {
//           await apiRequest(`/documents/${documentId}`, {
//             method: 'DELETE'
//           });
          
//           showNotification('success', 'Document șters cu succes!');
//           loadDocuments();
//           loadStatistics();
//         } catch (error) {
//           showNotification('error', 'Eroare la ștergere document.');
//         }
//       },
//       'danger'
//     );
//   };

//   // Export documente
//   const handleExport = async () => {
//     try {
//       const queryParams = new URLSearchParams();
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) queryParams.append(key, value);
//       });
//       queryParams.append('format', 'csv');

//       // Folosim fetch cu token în loc de window.location.href
//       const token = localStorage.getItem('token');
//       const response = await fetch(`${API_URL}/export?${queryParams}`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       });

//       if (!response.ok) {
//         throw new Error('Eroare la export');
//       }

//       // Obține conținutul CSV
//       const blob = await response.blob();
      
//       // Creează un link de download
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `registru_${new Date().toISOString().split('T')[0]}.csv`;
//       document.body.appendChild(a);
//       a.click();
      
//       // Cleanup
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);
      
//       showNotification('success', 'Export CSV realizat cu succes!');
//     } catch (error) {
//       showNotification('error', 'Eroare la export CSV. Vă rugăm încercați din nou.');
//       console.error('Export error:', error);
//     }
//   };

//   // Logout
//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     setUser(null);
//   };

//   // Dacă nu e autentificat, afișează login
//   if (!user) {
//     return <LoginPage onLogin={setUser} />;
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <header className="bg-white shadow-sm border-b">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-16">
//             <div className="flex items-center gap-8">
//               <div className="flex items-center gap-3">
//                 <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white w-10 h-10 rounded-lg flex items-center justify-center">
//                   <FileText className="w-5 h-5" />
//                 </div>
//                 <h1 className="text-xl font-bold">Registru Electronic</h1>
//               </div>

//               <nav className="flex gap-4">
//                 <button
//                   onClick={() => setActiveView('dashboard')}
//                   className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                     activeView === 'dashboard' 
//                       ? 'bg-blue-50 text-blue-600' 
//                       : 'text-gray-600 hover:text-gray-900'
//                   }`}
//                 >
//                   Dashboard
//                 </button>
//                 <button
//                   onClick={() => setActiveView('documents')}
//                   className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                     activeView === 'documents' 
//                       ? 'bg-blue-50 text-blue-600' 
//                       : 'text-gray-600 hover:text-gray-900'
//                   }`}
//                 >
//                   Documente
//                 </button>
//               </nav>
//             </div>

//             <div className="flex items-center gap-4">
//               <div className="flex items-center gap-2">
//                 <User className="w-5 h-5 text-gray-500" />
//                 <span className="font-medium">{user.fullName}</span>
//                 <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
//                   user.role === 'admin' 
//                     ? 'bg-purple-100 text-purple-800' 
//                     : 'bg-gray-100 text-gray-800'
//                 }`}>
//                   {user.role === 'admin' ? 'Admin' : 'User'}
//                 </span>
//               </div>
//               <button
//                 onClick={handleLogout}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <LogOut className="w-5 h-5" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main>
//         {activeView === 'dashboard' && (
//           <DashboardView 
//             statistics={statistics} 
//             user={user}
//             year={dashboardYear}
//             onYearChange={(year) => {
//               setDashboardYear(year);
//             }}
//           />
//         )}
//         {activeView === 'documents' && (
//           <DocumentsView 
//             companies={companies}
//             documents={documents}
//             loading={loading}
//             filters={filters}
//             setFilters={setFilters}
//             onAddNew={() => setShowAddForm(true)}
//             onExport={handleExport}
//             onLoadDocuments={loadDocuments}
//             onDeleteDocument={handleDeleteDocument}
//             user={user}
//           />
//         )}
//       </main>

//       {/* Modal formular adăugare */}
//       {showAddForm && (
//         <AddDocumentForm 
//           companies={companies}
//           formData={formData}
//           setFormData={setFormData}
//           onSave={handleAddDocument}
//           onCancel={() => setShowAddForm(false)}
//         />
//       )}

//       {/* Notificări */}
//       {notification && (
//         <Notification
//           type={notification.type}
//           message={notification.message}
//           onClose={() => setNotification(null)}
//         />
//       )}

//       {/* Dialog confirmare */}
//       <ConfirmDialog
//         isOpen={confirmDialog.isOpen}
//         title={confirmDialog.title}
//         message={confirmDialog.message}
//         onConfirm={confirmDialog.onConfirm}
//         onCancel={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
//         type={confirmDialog.type}
//       />
//     </div>
//   );
// };

// export default DocumentRegistry;

import React, { useState, useEffect, useCallback } from 'react';
import { 
  FileText, User, Building, Download, Plus, Filter, 
  LogOut, Search, Trash2, Activity, CheckCircle, XCircle, AlertCircle, X, Edit2
} from 'lucide-react';

// Configurare API
const API_URL = process.env.REACT_APP_API_URL || 'https://registru.blueforest.ro/api';

// Helper pentru request-uri API
const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
      ...(token && { 'Authorization': `Bearer ${token}` })
    }
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...defaultOptions,
    ...options,
    headers: { ...defaultOptions.headers, ...options.headers }
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    throw new Error(`API Error: ${response.status}`);
  }

  return response.json();
};

// Componenta de Notificare Custom
const Notification = ({ type, message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const styles = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-400',
      text: 'text-green-800',
      icon: <CheckCircle className="w-5 h-5" />,
      iconColor: 'text-green-400'
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-400',
      text: 'text-red-800',
      icon: <XCircle className="w-5 h-5" />,
      iconColor: 'text-red-400'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-400',
      text: 'text-yellow-800',
      icon: <AlertCircle className="w-5 h-5" />,
      iconColor: 'text-yellow-400'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-400',
      text: 'text-blue-800',
      icon: <AlertCircle className="w-5 h-5" />,
      iconColor: 'text-blue-400'
    }
  };

  const style = styles[type] || styles.info;

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in">
      <div className={`${style.bg} border ${style.border} ${style.text} px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px] max-w-[500px]`}>
        <span className={style.iconColor}>{style.icon}</span>
        <p className="flex-1">{message}</p>
        <button
          onClick={onClose}
          className={`${style.iconColor} hover:opacity-70 transition-opacity`}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

// Componenta de Confirmare Custom
const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, type = 'warning' }) => {
  if (!isOpen) return null;

  const styles = {
    warning: {
      icon: <AlertCircle className="w-12 h-12 text-yellow-500" />,
      confirmBtn: 'bg-yellow-600 hover:bg-yellow-700'
    },
    danger: {
      icon: <XCircle className="w-12 h-12 text-red-500" />,
      confirmBtn: 'bg-red-600 hover:bg-red-700'
    }
  };

  const style = styles[type] || styles.warning;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4 animate-scale-in">
        <div className="flex flex-col items-center text-center">
          {style.icon}
          <h3 className="text-xl font-bold mt-4 mb-2">{title}</h3>
          <p className="text-gray-600 mb-6">{message}</p>
          <div className="flex gap-3 w-full">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Anulează
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 px-4 py-2 text-white rounded-lg transition-colors ${style.confirmBtn}`}
            >
              Confirmă
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Adaugă stilurile CSS pentru animații
const styles = `
  @keyframes slide-in {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes scale-in {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  .animate-slide-in {
    animation: slide-in 0.3s ease-out;
  }

  .animate-scale-in {
    animation: scale-in 0.2s ease-out;
  }
`;

// Adaugă stilurile în document
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

// Componenta de Login
const LoginPage = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await apiRequest('/auth/login', {
        method: 'POST',
        body: JSON.stringify(credentials)
      });

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onLogin(data.user);
    } catch (err) {
      setError('Utilizator sau parolă incorectă');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <FileText className="w-8 h-8" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Registru Electronic</h1>
          <p className="text-gray-600 mt-2">Sistem de înregistrare documente</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg mb-4">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Utilizator
            </label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Introduceți numele de utilizator"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Parolă
            </label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Introduceți parola"
              required
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50"
          >
            {loading ? 'Se conectează...' : 'Conectare'}
          </button>
        </div>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>Utilizatori disponibili:</p>
          <p className="mt-1">Admin: emilia | Useri: cosmin, radu, nicu, darius, rares, felicia</p>
        </div>
      </div>
    </div>
  );
};

// Dashboard View Component
const DashboardView = ({ statistics, user, year, onYearChange }) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-2xl font-bold">Dashboard</h2>
      <select
        value={year}
        onChange={(e) => onYearChange(parseInt(e.target.value))}
        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
      >
        <option value="2024">2024</option>
        <option value="2025">2025</option>
      </select>
    </div>
    
    {/* Statistici pe companii */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {statistics?.companyStats.map(company => (
        <div key={company.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                 style={{ backgroundColor: company.color + '20' }}>
              <Building className="w-6 h-6" style={{ color: company.color }} />
            </div>
            <span className="text-2xl font-bold">{company.total_documents}</span>
          </div>
          <h3 className="font-semibold text-gray-800">{company.short_name}</h3>
          <div className="mt-2 text-sm text-gray-600">
            <p>Intrări: {company.total_intrari}</p>
            <p>Ieșiri: {company.total_iesiri}</p>
          </div>
        </div>
      ))}
    </div>

    {/* Activitate recentă */}
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Activity className="w-5 h-5" />
        Activitate Recentă
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b">
              <th className="text-left p-2">Nr.</th>
              <th className="text-left p-2">Data</th>
              <th className="text-left p-2">Companie</th>
              <th className="text-left p-2">Tip</th>
              <th className="text-left p-2">Creat de</th>
            </tr>
          </thead>
          <tbody>
            {statistics?.recentActivity.map(doc => (
              <tr key={doc.id} className="border-b hover:bg-gray-50">
                <td className="p-2">{doc.number}</td>
                <td className="p-2">{new Date(doc.date).toLocaleDateString('ro-RO')}</td>
                <td className="p-2">{doc.company_name}</td>
                <td className="p-2">
                  <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                    doc.registry_type === 'intrare' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                  }`}>
                    {doc.registry_type}
                  </span>
                </td>
                <td className="p-2">{doc.created_by_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

// Edit Document Form Component
const EditDocumentForm = ({ document, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    number: document.number,
    number_intrare: document.number_intrare || '',
    date: document.date.split('T')[0],
    from_entity: document.from_entity,
    to_entity: document.to_entity,
    content: document.content,
    redirectionare: document.redirectionare || '',
    opid: document.opid || ''
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    await onSave(document.id, formData);
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <h3 className="text-xl font-bold mb-4">Editează Document</h3>
        
        <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
          <p className="text-sm text-yellow-800">
            <strong>Companie:</strong> {document.company_name} (nu poate fi modificată)
          </p>
          <p className="text-sm text-yellow-800 mt-1">
            <strong>Tip registru:</strong> {document.registry_type}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Număr
            </label>
            <input
              type="text"
              value={formData.number}
              onChange={(e) => setFormData({ ...formData, number: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Data
            </label>
            <input
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {document.registry_type === 'intrare' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nr. Intrare
              </label>
              <input
                type="text"
                value={formData.number_intrare}
                onChange={(e) => setFormData({ ...formData, number_intrare: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              De la / Von
            </label>
            <input
              type="text"
              value={formData.from_entity}
              onChange={(e) => setFormData({ ...formData, from_entity: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              La / Zu
            </label>
            <input
              type="text"
              value={formData.to_entity}
              onChange={(e) => setFormData({ ...formData, to_entity: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Conține / Enthält
            </label>
            <textarea
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              rows="3"
            />
          </div>

          {document.registry_type === 'intrare' && (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Redirecționare
                </label>
                <input
                  type="text"
                  value={formData.redirectionare}
                  onChange={(e) => setFormData({ ...formData, redirectionare: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  OPID
                </label>
                <input
                  type="text"
                  value={formData.opid}
                  onChange={(e) => setFormData({ ...formData, opid: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </>
          )}
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onCancel}
            disabled={saving}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Anulează
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed ${
              saving ? 'animate-pulse' : ''
            }`}
          >
            {saving ? 'Se salvează...' : 'Salvează modificările'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Documents View Component
const DocumentsView = ({ 
  companies, 
  documents, 
  loading, 
  filters, 
  setFilters, 
  onAddNew, 
  onExport, 
  onLoadDocuments,
  onDeleteDocument,
  onEditDocument,
  user 
}) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-2xl font-bold">Documente</h2>
      <div className="flex gap-2">
        <button
          onClick={onAddNew}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Document Nou
        </button>
        <button
          onClick={onExport}
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center gap-2"
        >
          <Download className="w-4 h-4" />
          Export CSV
        </button>
      </div>
    </div>

    {/* Filtre */}
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <select
          value={filters.company_id}
          onChange={(e) => setFilters({ ...filters, company_id: e.target.value })}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Toate companiile</option>
          {companies.map(company => (
            <option key={company.id} value={company.id}>{company.name}</option>
          ))}
        </select>

        <select
          value={filters.registry_type}
          onChange={(e) => setFilters({ ...filters, registry_type: e.target.value })}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Toate tipurile</option>
          <option value="intrare">Intrări</option>
          <option value="iesire">Ieșiri</option>
        </select>

        <input
          type="number"
          value={filters.year}
          onChange={(e) => setFilters({ ...filters, year: e.target.value })}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="An"
        />

        <div className="relative">
          <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
          <input
            type="text"
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 w-full"
            placeholder="Caută..."
          />
        </div>

        <button
          onClick={onLoadDocuments}
          className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 flex items-center justify-center gap-2"
        >
          <Filter className="w-4 h-4" />
          Filtrează
        </button>
      </div>
    </div>

    {/* Tabel documente */}
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      {loading ? (
        <div className="p-8 text-center">Se încarcă...</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-3 text-left">Nr.</th>
                <th className="p-3 text-left">Nr. Intrare</th>
                <th className="p-3 text-left">Data</th>
                <th className="p-3 text-left">Companie</th>
                <th className="p-3 text-left">Tip</th>
                <th className="p-3 text-left">De la</th>
                <th className="p-3 text-left">La</th>
                <th className="p-3 text-left">Conține</th>
                <th className="p-3 text-left">Creat de</th>
                {user.role === 'admin' && <th className="p-3 text-left">Acțiuni</th>}
              </tr>
            </thead>
            <tbody>
              {documents.map(doc => (
                <tr key={doc.id} className="border-b hover:bg-gray-50">
                  <td className="p-3 font-semibold">{doc.number}</td>
                  <td className="p-3">{doc.number_intrare || '-'}</td>
                  <td className="p-3">{new Date(doc.date).toLocaleDateString('ro-RO')}</td>
                  <td className="p-3">
                    <span className="px-2 py-1 rounded-full text-xs font-semibold text-white"
                          style={{ backgroundColor: doc.company_color }}>
                      {doc.company_short}
                    </span>
                  </td>
                  <td className="p-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                      doc.registry_type === 'intrare' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                    }`}>
                      {doc.registry_type}
                    </span>
                  </td>
                  <td className="p-3 text-sm">{doc.from_entity}</td>
                  <td className="p-3 text-sm">{doc.to_entity}</td>
                  <td className="p-3 text-sm">{doc.content}</td>
                  <td className="p-3 text-sm">{doc.created_by_name}</td>
                  {user.role === 'admin' && (
                    <td className="p-3">
                      <div className="flex gap-2">
                        <button
                          onClick={() => onEditDocument(doc)}
                          className="text-blue-600 hover:text-blue-800"
                          title="Editează document"
                        >
                          <Edit2 className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => onDeleteDocument(doc.id)}
                          className="text-red-600 hover:text-red-800"
                          title="Șterge document"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

// Add Document Form Component
// Add Document Form Component - Versiune îmbunătățită
const AddDocumentForm = ({ companies, formData, setFormData, onSave, onCancel }) => {
  const [saving, setSaving] = useState(false);
  
  // Găsește numele companiei selectate
  const selectedCompany = companies.find(c => c.id === parseInt(formData.company_id));
  const companyName = selectedCompany ? selectedCompany.name : '';
  
  // Actualizează automat câmpurile "De la" sau "La" când se schimbă compania sau tipul
  useEffect(() => {
    if (formData.company_id) {
      if (formData.registry_type === 'iesire') {
        // Pentru ieșire: compania selectată este expeditorul
        setFormData(prev => ({ ...prev, from_entity: companyName }));
      } else {
        // Pentru intrare: compania selectată este destinatarul
        setFormData(prev => ({ ...prev, to_entity: companyName }));
      }
    }
  }, [formData.company_id, formData.registry_type, companyName, setFormData]);
  
  const handleSave = async () => {
    setSaving(true);
    await onSave();
    setSaving(false);
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <h3 className="text-xl font-bold mb-4">Adaugă Document Nou</h3>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Companie <span className="text-red-500">*</span>
            </label>
            <select
              value={formData.company_id}
              onChange={(e) => setFormData({ ...formData, company_id: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Selectează...</option>
              {companies.map(company => (
                <option key={company.id} value={company.id}>{company.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tip Registru <span className="text-red-500">*</span>
            </label>
            <select
              value={formData.registry_type}
              onChange={(e) => setFormData({ ...formData, registry_type: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="iesire">Ieșire</option>
              <option value="intrare">Intrare</option>
            </select>
          </div>

          {formData.registry_type === 'intrare' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nr. Intrare
              </label>
              <input
                type="text"
                value={formData.number_intrare}
                onChange={(e) => setFormData({ ...formData, number_intrare: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Data <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Afișează info despre câmpurile auto-completate */}
          {formData.company_id && (
            <div className="col-span-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-800">
                {formData.registry_type === 'iesire' 
                  ? `📤 Document de ieșire: "${companyName}" trimite către...`
                  : `📥 Document de intrare: "${companyName}" primește de la...`
                }
              </p>
            </div>
          )}

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              De la / Von {formData.registry_type === 'intrare' && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              value={formData.from_entity}
              onChange={(e) => setFormData({ ...formData, from_entity: e.target.value })}
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 ${
                formData.registry_type === 'iesire' ? 'bg-gray-100' : ''
              }`}
              readOnly={formData.registry_type === 'iesire'}
              required={formData.registry_type === 'intrare'}
              placeholder={formData.registry_type === 'iesire' ? 'Completat automat' : 'Introduceți expeditorul'}
            />
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              La / Zu {formData.registry_type === 'iesire' && <span className="text-red-500">*</span>}
            </label>
            <input
              type="text"
              value={formData.to_entity}
              onChange={(e) => setFormData({ ...formData, to_entity: e.target.value })}
              className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 ${
                formData.registry_type === 'intrare' ? 'bg-gray-100' : ''
              }`}
              readOnly={formData.registry_type === 'intrare'}
              required={formData.registry_type === 'iesire'}
              placeholder={formData.registry_type === 'intrare' ? 'Completat automat' : 'Introduceți destinatarul'}
            />
          </div>

          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Conține / Enthält <span className="text-red-500">*</span>
            </label>
            <textarea
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              rows="3"
              required
            />
          </div>

          {formData.registry_type === 'intrare' && (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Redirecționare
                </label>
                <input
                  type="text"
                  value={formData.redirectionare}
                  onChange={(e) => setFormData({ ...formData, redirectionare: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  OPID
                </label>
                <input
                  type="text"
                  value={formData.opid}
                  onChange={(e) => setFormData({ ...formData, opid: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </>
          )}
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onCancel}
            disabled={saving}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Anulează
          </button>
          <button
            onClick={handleSave}
            disabled={saving || !formData.company_id}
            className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed ${
              saving ? 'animate-pulse' : ''
            }`}
          >
            {saving ? 'Se salvează...' : 'Salvează'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Componenta principală
const DocumentRegistry = () => {
  const [user, setUser] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeView, setActiveView] = useState('dashboard');
  const [dashboardYear, setDashboardYear] = useState(2025);
  
  // State pentru notificări
  const [notification, setNotification] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null,
    type: 'warning'
  });
  
  // State pentru editare
  const [editingDocument, setEditingDocument] = useState(null);
  
  // Filtre pentru documente
  const [filters, setFilters] = useState({
    company_id: '',
    registry_type: '',
    year: 2025,
    search: ''
  });

  // Form pentru document nou
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    company_id: '',
    registry_type: 'iesire',
    number_intrare: '',
    date: new Date().toISOString().split('T')[0],
    from_entity: '',
    to_entity: '',
    content: '',
    redirectionare: '',
    opid: ''
  });

  // Funcții helper pentru notificări
  const showNotification = (type, message) => {
    setNotification({ type, message });
  };

  const showConfirmDialog = (title, message, onConfirm, type = 'warning') => {
    setConfirmDialog({
      isOpen: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
      },
      type
    });
  };

  // Încărcare companii
  const loadCompanies = async () => {
    try {
      const data = await apiRequest('/companies');
      setCompanies(data);
    } catch (error) {
      console.error('Eroare la încărcare companii:', error);
    }
  };

  // Încărcare statistici
  const loadStatistics = useCallback(async () => {
    try {
      const data = await apiRequest(`/statistics?year=${dashboardYear}`);
      setStatistics(data);
    } catch (error) {
      console.error('Eroare la încărcare statistici:', error);
    }
  }, [dashboardYear]);

  // Încărcare documente
  const loadDocuments = useCallback(async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });

      const data = await apiRequest(`/documents?${queryParams}`);
      setDocuments(data.documents);
    } catch (error) {
      console.error('Eroare la încărcare documente:', error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  // Verificare autentificare la încărcare
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  // Încărcare date inițiale
  useEffect(() => {
    if (user) {
      loadCompanies();
    }
  }, [user]);

  // Încărcare date pe baza view-ului activ
  useEffect(() => {
    if (user) {
      if (activeView === 'dashboard') {
        loadStatistics();
      } else if (activeView === 'documents') {
        loadDocuments();
      }
    }
  }, [user, activeView, loadStatistics, loadDocuments]);

  // Reîncărcare statistici când se schimbă anul dashboard-ului
  useEffect(() => {
    if (user && activeView === 'dashboard') {
      loadStatistics();
    }
  }, [dashboardYear, user, activeView, loadStatistics]);

  // Adăugare document
  const handleAddDocument = async () => {
    try {
      const response = await apiRequest('/documents', {
        method: 'POST',
        body: JSON.stringify(formData)
      });

      showNotification('success', `Document înregistrat cu succes! Număr generat: ${response.generatedNumber}`);
      setShowAddForm(false);
      setFormData({
        company_id: '',
        registry_type: 'iesire',
        number_intrare: '',
        date: new Date().toISOString().split('T')[0],
        from_entity: '',
        to_entity: '',
        content: '',
        redirectionare: '',
        opid: ''
      });
      
      loadDocuments();
      loadStatistics();
    } catch (error) {
      showNotification('error', 'Eroare la adăugare document. Vă rugăm încercați din nou.');
    }
  };

  // Editare document
  const handleEditDocument = async (documentId, updatedData) => {
    try {
      await apiRequest(`/documents/${documentId}`, {
        method: 'PUT',
        body: JSON.stringify(updatedData)
      });
      
      showNotification('success', 'Document actualizat cu succes!');
      setEditingDocument(null);
      loadDocuments();
      loadStatistics();
    } catch (error) {
      showNotification('error', 'Eroare la actualizare document.');
    }
  };

  // Ștergere document
  const handleDeleteDocument = async (documentId) => {
    showConfirmDialog(
      'Confirmare ștergere',
      'Sigur doriți să ștergeți acest document? Această acțiune nu poate fi anulată.',
      async () => {
        try {
          await apiRequest(`/documents/${documentId}`, {
            method: 'DELETE'
          });
          
          showNotification('success', 'Document șters cu succes!');
          loadDocuments();
          loadStatistics();
        } catch (error) {
          showNotification('error', 'Eroare la ștergere document.');
        }
      },
      'danger'
    );
  };

  // Export documente
  const handleExport = async () => {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });
      queryParams.append('format', 'csv');

      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/export?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Eroare la export');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `registru_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      showNotification('success', 'Export CSV realizat cu succes!');
    } catch (error) {
      showNotification('error', 'Eroare la export CSV. Vă rugăm încercați din nou.');
      console.error('Export error:', error);
    }
  };

  // Logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  // Dacă nu e autentificat, afișează login
  if (!user) {
    return <LoginPage onLogin={setUser} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-8">
              <div className="flex items-center gap-3">
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white w-10 h-10 rounded-lg flex items-center justify-center">
                  <FileText className="w-5 h-5" />
                </div>
                <h1 className="text-xl font-bold">Registru Electronic</h1>
              </div>

              <nav className="flex gap-4">
                <button
                  onClick={() => setActiveView('dashboard')}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                    activeView === 'dashboard' 
                      ? 'bg-blue-50 text-blue-600' 
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Dashboard
                </button>
                <button
                  onClick={() => setActiveView('documents')}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                    activeView === 'documents' 
                      ? 'bg-blue-50 text-blue-600' 
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Documente
                </button>
              </nav>
            </div>

            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <User className="w-5 h-5 text-gray-500" />
                <span className="font-medium">{user.fullName}</span>
                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                  user.role === 'admin' 
                    ? 'bg-purple-100 text-purple-800' 
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {user.role === 'admin' ? 'Admin' : 'User'}
                </span>
              </div>
              <button
                onClick={handleLogout}
                className="text-gray-500 hover:text-gray-700"
              >
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {activeView === 'dashboard' && (
          <DashboardView 
            statistics={statistics} 
            user={user}
            year={dashboardYear}
            onYearChange={(year) => {
              setDashboardYear(year);
            }}
          />
        )}
        {activeView === 'documents' && (
          <DocumentsView 
            companies={companies}
            documents={documents}
            loading={loading}
            filters={filters}
            setFilters={setFilters}
            onAddNew={() => setShowAddForm(true)}
            onExport={handleExport}
            onLoadDocuments={loadDocuments}
            onDeleteDocument={handleDeleteDocument}
            onEditDocument={setEditingDocument}
            user={user}
          />
        )}
      </main>

      {/* Modal formular adăugare */}
      {showAddForm && (
        <AddDocumentForm 
          companies={companies}
          formData={formData}
          setFormData={setFormData}
          onSave={handleAddDocument}
          onCancel={() => setShowAddForm(false)}
        />
      )}

      {/* Modal formular editare */}
      {editingDocument && (
        <EditDocumentForm
          document={editingDocument}
          onSave={handleEditDocument}
          onCancel={() => setEditingDocument(null)}
        />
      )}

      {/* Notificări */}
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}

      {/* Dialog confirmare */}
      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        title={confirmDialog.title}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
        type={confirmDialog.type}
      />
    </div>
  );
};

export default DocumentRegistry;